

export function* getFilesFromDropEvent(event) {
    if (event.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (let i = 0; i < event.dataTransfer.items.length; i++) {
            // If dropped items aren't files, reject them
            if (event.dataTransfer.items[i].kind === 'file') {
                yield event.dataTransfer.items[i].getAsFile();
            }
        }
    } else {
        // Use DataTransfer interface to access the file(s)
        for (let i = 0; i < event.dataTransfer.files.length; i++) {
            yield event.dataTransfer.files[i]
        }
    }
}


export function readFileAsText(file) {
    return new Promise( (resolve, reject) => {
        if (file instanceof File) {
            try {
                const fileReader = new FileReader()
                fileReader.onload = (e) => {
                    resolve(e.target.result)
                }
                fileReader.readAsText(file)
            } catch (e) {
                reject(e)
            }
        } else {
            reject(new Error('File is not provided'))
        }
    })
}

export function absorbUntilDone(asyncFunction, byArg = -1, onError = err => console.log(err)) {
  const lock = new Map()
  const getKey = argumentList => (byArg === -1 || argumentList.length === 0) ? 0 : argumentList[byArg]
  return async function (...args) {
    const oldPromise = lock.get(getKey(args))
    if (oldPromise) {
      return await oldPromise
    }
    try {
      const promise = asyncFunction.apply(this, args)
      lock.set(getKey(args), promise)
      return await promise
    } catch (err) {
      onError(err)
    } finally {
      lock.set(getKey(args), null)
    }
  }
}

export function rgbToHex(color) {
  const [r, g, b] = color
  if (color.every(_ => 0 <= _ && _ <= 255)) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
  }
  return null
}

export function hexToRgb(hexString) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexString);
  return result
    ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
    : null;
}



// WEBPACK FOOTER //
// ./src/utils.js